import { IAMList } from 'containers/iam';
import React from 'react';
import { Navigate } from 'react-router-dom';
import Logout from '../components/Logout';
import * as Routes from './paths';
import { IRouteConfig } from './types';

const ROUTE_CONFIG: IRouteConfig[] = [
    {
        path: '/',
        element: <Navigate to={Routes.USER_LIST} replace />,
    },
    {
        path: Routes.ENTITY_USERS,
        Component: React.lazy(() => import('components/EntityUsers')),
    },
    {
        path: Routes.ENTITY_USERS_LEGACY,
        Component: React.lazy(() => import('components/EntityUsers')),
    },
    {
        path: Routes.USER_LIST,
        Component: React.lazy(() => import('components/EntityUsers')),
    },
    {
        path: Routes.FORBIDDEN,
        Component: React.lazy(() => import('components/Forbidden')),
    },
    /* {
    path: Routes.IAM,
    Component: React.lazy(() => import("containers/iam")),
  }, */
    {
        path: Routes.IAM_PRODUCT,
        Component: React.lazy(() => import('containers/iam')),
        children: [
            {
                path: Routes.IAM_PRODUCT,
                Component: IAMList,
            },
            {
                path: Routes.MANAGE_ROLES,
                Component: React.lazy(() => import('components/iam/ManageRoles')),
            },
            {
                path: Routes.MANAGE_USERS,
                Component: React.lazy(() => import('components/iam/ManageUsers')),
            },
        ],
    },
    {
        path: Routes.USER_LIST_LEGACY,
        Component: React.lazy(() => import('components/EntityUsers')),
    },
    {
        path: Routes.ALLOCATION_ENGINE,
        Component: React.lazy(() => import('components/AllocationEngine')),
        children: [
            {
                path: Routes.AE_BUSINESS_UNITS,
                Component: React.lazy(() => import('components/AllocationEngine/BusinessUnits')),
            },
            {
                path: Routes.AE_BUSINESS_UNIT_DETAIL,
                Component: React.lazy(
                    () => import('components/AllocationEngine/BusinessUnits/Detail')
                ),
            },
            {
                path: Routes.AE_BRANCH,
                Component: React.lazy(() => import('components/AllocationEngine/Branch')),
            },
            {
                path: Routes.AE_BRANCH_DETAIL,
                Component: React.lazy(() => import('components/AllocationEngine/Branch')),
            },
            {
                path: Routes.AE_BRANCH_MEMBER_DETAIL,
                Component: React.lazy(
                    () => import('components/AllocationEngine/Branch/Detail/member')
                ),
            },
            {
                path: Routes.AE_SUB_BRANCH,
                Component: React.lazy(() => import('components/AllocationEngine/SubBranch')),
            },
            {
                path: Routes.AE_SUB_BRANCH_DETAIL,
                Component: React.lazy(() => import('components/AllocationEngine/SubBranch')),
            },
            {
                path: Routes.AE_SUB_BRANCH_MAIN,
                Component: React.lazy(() => import('components/AllocationEngine/SubBranch/Detail')),
            },
            {
                path: Routes.GOVERNANCE_MODAL,
                Component: React.lazy(
                    () =>
                        import(
                            'components/AllocationEngine/BusinessUnits/Detail/PreferenceListing/GovernanceModal'
                        )
                ),
            },
            {
                path: Routes.MASTERS,
                Component: React.lazy(() => import('components/Masters')),
            },
            {
                path: Routes.MASTER_DETAIL,
                Component: React.lazy(() => import('components/Masters/MasterDetail')),
            },
            {
                path: Routes.MASTER_VERSIONS,
                Component: React.lazy(() => import('components/Masters/MasterVersion')),
            },
            {
                path: Routes.MASTER_VERSION_DETAIL,
                Component: React.lazy(() => import('components/Masters/MasterVersionDetail')),
            },
        ],
    },
    {
        path: Routes.MASTERS_CREATE_INFO,
        Component: React.lazy(() => import('components/Masters/StaticPage')),
        hideHeader: true,
    },
    {
        path: Routes.MASTERS_CREATION,
        Component: React.lazy(() => import('components/Masters/MastersCreation')),
        hideHeader: true,
    },
    {
        path: Routes.LOGOUT,
        Component: Logout,
    },
    {
        path: '/activate',
        Component: React.lazy(() => import('components/Activate')),
        publicRoute: true,
        hideHeader: true,
    },
    {
        path: '/forgot-password',
        Component: React.lazy(() => import('components/ForgotPassword')),
        publicRoute: true,
        hideHeader: true,
    },
    {
        path: '/set-password',
        Component: React.lazy(() => import('components/SetPassword')),
        publicRoute: true,
        hideHeader: true,
    },
    {
        path: '/change-password',
        Component: React.lazy(() => import('components/ChangePassword')),
        publicRoute: false,
        hideHeader: true,
    },
    {
        path: '*',
        Component: React.lazy(() => import('components/component-library/NotFound')),
    },
];

export const PUBLIC_ROUTES = ROUTE_CONFIG.filter((config) => config.publicRoute).map(
    (config) => config.path
);

export const HEADER_DISABLED_ROUTES = ROUTE_CONFIG.filter((config) => config.hideHeader).map(
    (config) => config.path
);

export default ROUTE_CONFIG;
